import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { OwlModule } from 'ngx-owl-carousel';
import { Angular2AirDatepickerModule } from 'angular2-air-datepicker';
import { LinkyModule } from 'angular-linky';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { Ng2EmojiModule } from 'ng2-emoji';
import { NgwWowModule } from 'ngx-wow';
import { RatingModule } from 'ngx-rating';

import { AppService } from './app.service';

import { AppComponent } from './app.component';



@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    OwlModule,
    Angular2AirDatepickerModule,
    LinkyModule,
    PickerModule,
    Ng2EmojiModule,
    NgwWowModule,
    RatingModule,
  ],
  providers: [
    AppService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
